import Vue from 'vue'
import Vuex from 'vuex'
import layoutModule from './store/modules/layout'
import userModule from './store/modules/user'
import onBoardModule from './store/modules/on-board'
import invitationCodeModule from './store/modules/invitation-code'
import institutionsModule from './store/modules/institutions'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

export default new Vuex.Store({
  modules: {
    layout: layoutModule,
    user: userModule,
    onBoard: onBoardModule,
    invitationCode: invitationCodeModule,
    institutions: institutionsModule
  },
  state: {
    domain: 'ecobanka',
    nextRoute: null
  },
  mutations: {
    SET_HOST(state, domain) {
      state.domain = domain
    },
    SET_NEXT_ROUTE(state, nextRoute) {
      state.nextRoute = {
        name: nextRoute.name,
        params: nextRoute.params,
        query: nextRoute.query
      }
    },
    UNSET_NEXT_ROUTE(state) {
      state.nextRoute = null
    }
  },
  getters: {
    domain: state => {
      return state.domain
    },
    nextRoute: state => {
      return state.nextRoute
    }
  },
  actions: {},
  plugins: [vuexLocal.plugin]
})
